import { Box, customStyled, Text, Flex } from '@mafc/trolly';
import { layout, typography } from 'styled-system';
import React from 'react';
import COLORS from 'theme/colors';

export const CustomBox = (props: any) => (
  <Box display={['block', null, 'inline', null]} {...props} />
);

export const Container = customStyled(CustomBox)(layout, typography);
export const PriceText = customStyled(Text.Paragraph)(props => ({
  display: 'block',
  color: COLORS.BLACK,
  fontWeight: 100,
}));

export const CashOnDeliveryContainer = customStyled(Flex)(props => ({
  alignItems: 'center',
  color: props.theme.colors.black,
}));
